module.exports = __webpack_public_path__ + "static/media/Sun-10.fc07a742.png";